import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'e-vault-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomeComponent {}
